import { createInstance, setLogLevel } from '@optimizely/react-sdk';
import config from 'JS/config/config';

let optimizely;

export default function getOptimizelyInstance() {
  if (optimizely) return optimizely;

  const { OPTIMIZELY_SDK_KEY, OPTIMIZELY_LOG_LEVEL } = config;

  optimizely = createInstance({
    sdkKey: OPTIMIZELY_SDK_KEY
  });
  setLogLevel(OPTIMIZELY_LOG_LEVEL);
  return optimizely;
}
